import {
  FETCH_FRANCHISE_LIST,
  RESET_FRANCHISE_LIST,
} from "../../constants/action.constants";

const initialState = {
  list: [],
  others: {},
};

const franchiseListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_FRANCHISE_LIST:
      return { list: action.payload, others: action.others };
    case RESET_FRANCHISE_LIST:
      return initialState;
    default:
      return state;
  }
};

export default franchiseListReducer;
